import { Box, Paper, Typography } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import BasicTabComponent from '../../components/BasicTabComponent';

import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';

import FormFieldData from '../../Models/FormFieldData';
import CommonForm from '../../components/form/CommonForm';
import ProjectQuoteDetails from './parts/QuoteDetails';
import ProjectDocuments from './parts/ProjectDocuments';
import ProjectCriticalChecks from './parts/ProjectCriticalChecks';
import ProjectPhotos from './parts/ProjectPhotos';
import ProjectSWMSOverview from './parts/ProjectSWMSOverview';
import ProjectCommunications from './parts/ProjectCommunications';
import IdLabelData from '../../Models/IdLabelData';
import ProjectDetails from './ProjectDetails';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import ProjectShiftList from './parts/ProjectShiftList';
import ProjectGanttChart from './parts/ProjectGanttChart';
import SimpleTabComponent from '../../components/SimpleTabComponent';

const ProjectOverview: React.FC = () => {
  const tabLabels = [
    'Quote',
    'Documents',
    'Shifts',
    'Gantt Chart',
    'Critical Checks',
    'Photos',
    'SWMS',
    'Communications',
  ];
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  const [documentTypeList, setDocumentTypeList] = useState<IdLabelData[]>([]);
  const isInitialLoad = useRef(true);
  const { currentId } = useParams<{ currentId: any }>();
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [quoteDetails, setQuoteDetails] = useState<any>(null);
  const [projectTemplateForm, setProjectTemplateForm] = React.useState({
    name: '',
    notes: '',
    cost: 0,
    id: null,
  });
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [customerEmail, setCustomerEmail] = useState<any>('');
  const [customerMainContact, setCustomerMainContact] = useState<any>('');

  const [loading, setLoading] = useState(false);
  const [projectDialogOpen, setProjectDialogOpen] = useState(false);
  const [companyDetails, setCompanyDetails] = React.useState<any>(null);
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const docRef = useRef();
  const projectFormFields: FormFieldData[] = [
    {
      name: 'customerEmail',
      label: 'Email',
      value: customerEmail,
      onChange: (e: any) => {
        setCustomerEmail(e.target.value);
      },
      isRequired: true,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Email is required' : '')],
    },
    {
      name: 'customerMainContact',
      label: 'Customer Contact',
      value: customerMainContact,
      onChange: (e: any) => {
        setCustomerMainContact(e.target.value);
      },
      isRequired: true,
      size: 12,
      type: 'textfield',
      validationRules: [
        (value) => (!value ? 'Customer Contact is required' : ''),
      ],
    },
  ];
  useEffect(() => {
    if (isInitialLoad.current) {
      if (currentId) {
        if (currentId !== 'Add') {
          fetchSingleRecord(currentId);
          fetchDocumentTypes();
          fetchCompany();
          if (location.hash === '#documents') {
            changeTabHandler(1);
            setTabIndex(1);
          }
          console.log('Current hash:', location.hash);
        }
      } else {
        setCurrentRecord(null);
      }

      isInitialLoad.current = false;
    }
  }, [currentId]);

  const fetchSingleRecord = async (id: any) => {
    try {
      const response = await HttpServices.get(
        Constants.apiURL + Constants.projectDashboardsURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        null
      );
      if (response.success) {
        handleRowClick(response.data);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const getQuoteTotalPrice = (quoteData: any) => {
    const newItems = quoteData.billables;
    const totalCost = newItems.reduce((acc: number, item: any) => {
      const itemCost = item.resources.reduce(
        (detailAcc: number, detail: any) => {
          return (
            detailAcc +
            parseInt(detail['items'][0].quantity) *
              parseFloat(detail['items'][0].price)
          );
        },
        0
      );
      return acc + itemCost;
    }, 0);
    return isNaN(totalCost) ? 0.0 : totalCost;
  };
  const fetchQuote = async (id: any) => {
    try {
      const response = await HttpServices.get(
        Constants.apiURL + Constants.quoteURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );

      if (response.success) {
        if (response.data) {
          const quoteData: any = response.data;
          console.log(`quoteData`);
          console.log(quoteData);
          console.log(`quoteData`);
          setQuoteDetails(quoteData);
          setProjectTemplateForm({
            name: quoteData.projectName,
            notes: '',
            cost: quoteData.quoteSubmissionPrice
              ? getQuoteTotalPrice(quoteData)
              : 0,
            id: null,
          });
        }
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  // Fetch single term record
  const fetchCompany = async () => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.fetchQuoteCompanyProfile}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      if (response.data) {
        setCompanyDetails(response.data);
      }
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleRowClick = async (data: any) => {
    setCurrentRecord(data);
    setCustomerEmail(data.customerEmail);
    setCustomerMainContact(data.customerMainContact);
    await fetchQuote(data.quoteId);
  };

  const clearForm = () => {
    setCustomerEmail('');
    setCustomerMainContact('');
    setProjectDialogOpen(false);
    fetchSingleRecord(currentId);
  };
  const handleSaveProject = async () => {
    setLoading(true);
    const reqData: any = {
      projectInternalId: currentRecord.projectInternalId,
      customerEmail: customerEmail,
      customerMainContact: customerMainContact,
    };
    const endpoint = `${Constants.apiURL + Constants.projectDashboardsURL}`;
    let response: any;
    try {
      response = await HttpServices.put(endpoint, reqData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });

      if (response.success) {
        clearForm();
      }
    } catch (error: any) {
      console.error(`PUT ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchDocumentTypes = async () => {
    try {
      const URL = `${Constants.apiURL}${Constants.refBundleURL}/fetchDocumentTypes`;
      const response = await HttpServices.get(
        URL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { type: 'project' }
      );
      if (response.data) {
        setDocumentTypeList(response.data ? response.data : []);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const ProjectDialogContent = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <CommonForm
          fields={projectFormFields}
          onCancel={() => {}}
          formReset={clearForm}
          formTitle={'Edit Project'}
          isLoading={loading}
          isUpdate={true}
          onSave={handleSaveProject}
          actionButtonPosition="bottom"
          singlePage={true}
        />
      </Box>
    );
  };

  const TabContent = () => {
    return (
      <Box sx={{ display: 'grid', gap: '16px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        ></Box>

        {tabIndex === 0 && (
          <ProjectQuoteDetails
            details={quoteDetails}
            companyDetails={companyDetails}
            projectTemplateForm={projectTemplateForm}
          />
        )}
        {tabIndex === 1 && currentRecord && (
          <ProjectDocuments
            projectInternalId={currentRecord.projectInternalId}
            customerEmail={currentRecord.customerEmail}
            customerName={currentRecord.customerMainContact}
            projectName={currentRecord.projectName}
            documentTypeList={documentTypeList}
          />
        )}
        {tabIndex === 2 && currentRecord && (
          <ProjectShiftList
            projectInternalId={currentRecord.projectInternalId}
          />
        )}
        {tabIndex === 3 && currentRecord && (
          <ProjectGanttChart
            projectInternalId={currentRecord.projectInternalId}
          />
        )}
        {tabIndex === 4 && currentRecord && (
          <ProjectCriticalChecks
            projectInternalId={currentRecord.projectInternalId}
          />
        )}
        {tabIndex === 5 && currentRecord && (
          <ProjectPhotos
            details={currentRecord}
            projectInternalId={currentRecord.projectInternalId}
          />
        )}
        {tabIndex === 6 && currentRecord && (
          <ProjectSWMSOverview
            projectInternalId={currentRecord.projectInternalId}
          />
        )}
        {tabIndex === 7 && currentRecord && (
          <ProjectCommunications
            projectInternalId={currentRecord.projectInternalId}
          />
        )}
      </Box>
    );
  };

  const changeTabHandler = async (newIndex: number) => setTabIndex(newIndex);

  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <div
              onClick={() => {
                navigate('/project-dashboard/project');
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <UTurnLeftIcon
                sx={{
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
              />
              <Typography>Back</Typography>
            </div>

            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  padding: '24px 16px 16px 16px',
                  mb: 2,
                  display: 'grid',
                  gap: '32px',
                  overflowX: 'scroll',
                }}
              >
                {currentRecord && (
                  <ProjectDetails
                    currentRecord={currentRecord}
                    onSave={clearForm}
                  />
                )}

                <SimpleTabComponent
                  currentTab={tabIndex}
                  labels={tabLabels}
                  tabContent={<TabContent />}
                  onChangeTab={changeTabHandler}
                />
              </Box>
              <SimpleDialogComponent
                title={''}
                dialogContent={ProjectDialogContent()}
                open={projectDialogOpen}
                handleClose={() => {
                  setProjectDialogOpen(false);
                }}
              />
            </Paper>
          </div>
        </div>
      </section>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};

export default ProjectOverview;
